import React from 'react'
import { observer } from 'mobx-react'
import { WorkspaceWindow } from './Workspace.window'
import styled from 'styled-components'

export default observer(({ store }) => {



  return (
      <ViewerWorkspaces className='fade-in'>
        {store.workspace.map((window, i) => {
          return window.id ?(
              <WorkspaceWindow
                  {...store?.attributes}
                  {...window}
                  magnifier={store.magnifier}
                  id={window.id}
                  store={store}
                  key={window.id}
                  isMain={store.history.length==1}
                  isActual={window.id === store.selectedWindowId}
                  selectWindow={store.selectWindow}
              />
          ) : undefined
        })}
      </ViewerWorkspaces>
  )
})

const ViewerWorkspaces = styled.div`
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  position: absolute;
  right: 149px;
  left: 0;
`
